export const environment = {
  production: true,
  demo: false,
  stage: '',
};

export const api = {
  baseUrl: 'https://api-dev-hr-pico.adpl.it',
  prefixAuthorization: 'Bearer',
  endpoint: {
    login: 'auth/admin/login',
    active: 'auth/active',
    register: 'auth/register',
    resetPassword: 'auth/recovery-password',
    changePassword: 'auth/change-password',
    logout: 'auth/logout',
  },
};
